import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { textOverflowLineClamp } from '@r1-frontend/ui-react/tokens/others/textOverflowLineClamp';

export const BlockTitle = styled(H4)`
    ${textOverflowLineClamp(3)};
`;

export const AdvantagesGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;

    @media (min-width: ${wideBreakpoints.mobile}) {
        gap: 16px;
    }
`;
